import { ChevronLeftIcon } from '@chakra-ui/icons';
import { Box, Container, Heading, Link, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { Link as ReactRouterLink, useRouteError } from 'react-router-dom';
import { PagePath } from '../../constants/routes';

export const Error: FC = () => {
    const error = useRouteError() as { status?: number };
    const code = error?.status || null;

    const heading =
        code === 404
            ? 'Pagina niet gevonden'
            : code === 401
              ? 'Niet geautoriseerd'
              : `Foutcode ${code}`;

    const body =
        code === 404
            ? 'Mogelijk bestaat de pagina niet meer of is de URL onjuist.'
            : code === 401
              ? 'U heeft geen toegang tot deze pagina mogelijk dient u hiervoor opnieuw in te loggen.'
              : null;

    return (
        <Box px={8} py={8}>
            <Link
                as={ReactRouterLink}
                to={PagePath.StockOverview}
                mb={2}
                display={'inline-block'}
            >
                <ChevronLeftIcon />
                Terug naar overzicht
            </Link>
            <Container maxW={'4xl'} px={0}>
                <Heading color={'secondary'}>{heading}</Heading>
                {body && <Text mb={6}>{body}</Text>}
            </Container>
        </Box>
    );
};
